import { render } from "./BookingCreate.vue?vue&type=template&id=2679890e"
import script from "./BookingCreate.vue?vue&type=script&lang=js"
export * from "./BookingCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\MartinRud-CloudRoot\\Firma\\Code\\PHP\\byensegenbil.dk\\byensegenbil.dk-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__